import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="relative mt-4 w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20warm%20illustration%20of%20many%20overlapping%20speech%20bubbles%20forming%20a%20river%20with%20lily%20pads%2C%20deep%20crimson%20and%20amber%20tones%2C%20grainy%20retro%20editorial%20poster%20texture&width=1600&height=700&seq=gua-cta-band&orientation=landscape"
          alt="众多聊天气泡汇聚成河流的插画"
          title="蝌蚪吃瓜 - 加入合集补课"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/35"></div>
      <div className="relative mx-auto flex max-w-[1280px] flex-col items-start gap-5 px-4 py-16 md:px-6 md:py-20">
        <h2 className="max-w-xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
          有个错过的瓜？说出来，我们帮你考古
        </h2>
        <p className="max-w-lg text-sm leading-relaxed text-background-50/80 md:text-base">
          把话题名称和你记得的时间点告诉我们，整理团队会评估信息完整度，合适的排入考古计划。
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/contact"
            className="flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-send-plane-line"></i>
            推荐一个话题
          </Link>
          <Link
            to="/heji"
            className="flex items-center gap-2 rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 whitespace-nowrap"
          >
            先去翻合集
          </Link>
        </div>
      </div>
    </section>
  );
}